import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "react-dual-listbox/lib/react-dual-listbox.css";
import Parametros from "../Parametros";
import UserTab from "../UserTab";
import Table from "../Table";
import CurrentUser from "../CurrentUser";
function AgregarSucursal(props) {
  //
  const { history } = props;
  const [usuario] = useState(JSON.parse(props.location.state.item));
  const [sucursales, setSucursales] = useState([]);
  const [sucursalesUpdate, setSucursalesUpdate] = useState([]);
  const [editable, setEditable] = useState("");
  const [update, setUpdate] = useState(false);
  // eslint-disable-next-line
  const [usuarioDev, setUsuarioDev] = useState(CurrentUser.user);
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  useEffect(() => {
    async function llamadaApi() {
      // let responseSucursal = await fetch(Parametros.urlApi+"branches/" + usuario.person_uid)
      let responseSucursal = await fetch(
        Parametros.urlApi + "branches/" + usuario.person_uid,
        {
          headers: {
            Authorization: "Bearer " + usuarioDev.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );
      if (responseSucursal.status === 200 || responseSucursal.status === 201) {
        let responseSucursalJson = await responseSucursal.json();

        setSucursales(responseSucursalJson);
        setSucursalesUpdate(responseSucursalJson);
      } else if (responseSucursal.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        // history.push({
        //     pathname: '/'
        // })
      }
    }
    llamadaApi();
  }, [update, usuario, usuarioDev]);

  const [formularioState, setFormularioState] = useState({
    branch_name: "",
  });
  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };

  let crearSucursal = async (event) => {
    event.preventDefault();
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let newAray = formularioState;
      newAray.client = usuario.person_uid;

      let response = await fetch(Parametros.post + "branches", {
        method: "POST",
        body: JSON.stringify(newAray),
        headers: {
          Authorization: "Bearer " + usuarioDev.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      });
      let responseJson = await response.json();

      if (response.status === 200 || response.status === 201) {
        alert("ok");

        document.getElementById("formularioBusqueda").reset();
        setUpdate(!update);
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      } else {
        alert(responseJson.detail);
      }
    } else {
      // Do nothing!
      // setEditable({})
      // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
    }
  };

  let guardarUnidadEditada = async (item, index) => {
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      // newAray.client = usuario.person_uid

      formularioUpdate.client = usuario.person_uid;
      let response = await fetch(Parametros.post + "branch/" + item.branch_id, {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + usuarioDev.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
        body: JSON.stringify(formularioUpdate),
      });
      let responseJson = await response.json();

      if (response.status === 200 || response.status === 201) {
        alert(responseJson.message);
        setUpdate(!update);
        setEditable({});
        setformularioUpdate({});

        // setSucursales(JSON.parse(JSON.stringify(newArray)))
        // setSucursalesUpdate(JSON.parse(JSON.stringify(newArray)))
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      } else {
        alert(responseJson.detail);
        setformularioUpdate({});
      }
    } else {
      // Do nothing!
      // setEditable({})
      // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
    }
  };

  let personaEmpresaHandleChange = (index, e) => {
    const name = e.target.getAttribute("name");
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    let newList = sucursales;
    newList[index][e.target.name] = value;
    setSucursales(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };

  let cancelarEdicion = () => {
    setSucursales(JSON.parse(JSON.stringify(sucursalesUpdate)));
    setEditable({});
    setformularioUpdate({});
  };
  let editar = (id) => {
    setSucursales(JSON.parse(JSON.stringify(sucursalesUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br></br>
      <UserTab nombre={"Asociar sucursal a empresa"}></UserTab>

      <div className="container">
        {/* <h1>Empresa</h1> */}
        <div className="col-md-6">
          <h4 style={{ fontWeight: "bold" }}>
            <b>Empresa</b>
          </h4>
          <p>{usuario.full_name}</p>
        </div>
        <div className="col-md-6">
          <h4 style={{ fontWeight: "bold" }}>
            <b>RUT</b>
          </h4>
          <p>{usuario.legal_id + "-" + usuario.verif_legal_id}</p>
        </div>
        {/* <div className='col-md-4'>
                    <h5 style={{ fontWeight: "bold" }}>Digito verificador</h5>
                    <p >{usuario.verif_legal_id}</p>
                </div> */}
        {/* <div className='col-md-4'>
                    <h5 style={{ fontWeight: "bold" }}>Tipo de persona</h5>
                    <p >{usuario.legal_type}</p>
                </div>
                <div className='col-md-4'>
                    <h5 style={{ fontWeight: "bold" }}>Nombre Completo</h5>
                    <p >{usuario.full_name}</p>
                </div>
                <div className='col-md-4'>
                    <h5 style={{ fontWeight: "bold" }}>Ciudad</h5>
                    <p >{usuario.country_id}</p>
                </div> */}

        <div className="col-md-12">
          <br></br>
          <br></br>

          <form id="formularioBusqueda" onSubmit={crearSucursal}>
            <div className="col-md-8" style={{ textAlign: "left" }}>
              <h5>Nueva sucursal</h5>
              <input
                onChange={handleStageForm}
                name="branch_name"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <br />
              <button
                type="submit"
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>

          <div
            className="col-md-12 table-responsive"
            style={{ height: 300, width: "100%" }}
          >
            {/* <h1>Sucursales</h1> */}
            <Table
              type={1}
              paginationBelow={true}
              paginas={Math.max(
                1,
                Math.ceil(sucursales.length / paginacionState.limit)
              )}
              paginadorState={paginacionState}
              setPaginadoor={setPaginacionState}
              elementos={["Sucursal"]}
            ></Table>
            <table className="table table-bordered" id="myTable">
              <Table type={2} elementos={["Sucursal"]}></Table>
              <tbody className="ajusteTabladata">
                {sucursales.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.branch_id}>
                      {editable === item.branch_id ? (
                        <>
                          <th>{item.branch_id}</th>
                          <td>
                            <input
                              value={item.branch_name}
                              name="branch_name"
                              onChange={(event) => {
                                personaEmpresaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>

                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  guardarUnidadEditada(item, index);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion();
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <th>{item.branch_id}</th>
                          <td>{item.branch_name} </td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.branch_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            {/* <abbr title="Eliminar Elemento"><span style={{ cursor: "pointer" }} onClick={() => { eliminarElemento(index, item) }} className='glyphicon glyphicon-remove'></span></abbr> */}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Table
              type={3}
              paginas={Math.max(
                1,
                Math.ceil(sucursales.length / paginacionState.limit)
              )}
              paginadorState={paginacionState}
              setPaginadoor={setPaginacionState}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(AgregarSucursal);
